import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { faqs } from '../data/seo';
import { Container, Eyebrow, sectionHeadingClass } from './ui/Primitives';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="border-t border-line" data-id="element-21" data-mp="1gketa1wi4tla">
      <Container className="py-20 md:py-28 lg:py-32" data-id="element-22" data-mp="248xyu9o62s9o">
        <div className="grid gap-10 md:grid-cols-12 md:gap-16" data-id="element-23" data-mp="24bk5m738h3qu">
          <div className="md:col-span-5" data-id="element-24" data-mp="289hybjw7q7yz">
            <Eyebrow data-id="element-25" data-mp="1ujefz40geyet">Common questions</Eyebrow>
            <h2 id="faq-heading" className={`mt-6 md:mt-7 ${sectionHeadingClass}`} data-id="element-26" data-mp="1uilg8mzwx966">
              Questions about the model.
            </h2>
          </div>

          <dl className="md:col-span-7" data-id="element-27" data-mp="2n8bx33sxip5z">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            const panelId = `faq-panel-${index}`;
            const buttonId = `faq-button-${index}`;
            return <div key={faq.question} className="border-b border-line first:border-t" data-id="element-28" data-mp="14vk27mhlp68l" data-mpi={index}>
                  <dt data-id="element-29" data-mp="10v9xse9ginvu">
                    <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-start justify-between gap-6 py-6 text-left" data-id="element-30" data-mp="10rm4ng7xc3hn">
                      <span className="font-display text-[19px] font-medium leading-snug tracking-tight text-ink sm:text-[21px]" data-id="element-31" data-mp="1jjx04p090z5q">
                        {faq.question}
                      </span>
                      <span aria-hidden="true" className="mt-0.5 shrink-0 text-navy transition-colors" data-id="element-32" data-mp="1slo3hn7bgtwf">
                        {isOpen ? <RemoveIcon sx={{
                      fontSize: 20
                    }} data-id="element-33" data-mp="3uecdqgidohlp" /> : <AddIcon sx={{
                      fontSize: 20
                    }} data-id="element-34" data-mp="1yb7kqwfmdt9k" />}
                      </span>
                    </button>
                  </dt>
                  <dd id={panelId} role="region" aria-labelledby={buttonId} hidden={!isOpen} className="max-w-prose pb-7 text-[15.5px] leading-relaxed text-graphite md:text-[16px]" data-id="element-35" data-mp="2867v7s5brlfj">
                    {faq.answer}
                  </dd>
                </div>;
          })}
          </dl>
        </div>
      </Container>
    </section>;
}